import styled from 'styled-components';

export const StyledIsEmptyMessage = styled.p`
  font-size: 12px;
  margin-top: 20px;
`;
